export default function SvgArrowRight(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg {...props} viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.3501 9.00867L0.802734 9.00867" stroke="white" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M12.4727 1.01721L18.0725 6.94924C19.1638 8.10528 19.1638 9.91192 18.0725 11.068L12.4727 17"
                  stroke="white" strokeWidth="2" strokeMiterlimit="10" />
        </svg>
    );
}
